import type DefaultFunnelEvent from "@/types/funnel/defaultFunnelEvent";
import type { InputEventProps } from "@/types/inputEventProps";
import type ContentIdFunnelEvent from "@/types/funnel/contentIdFunnelEvent";
import type TripIdFunnelEvent from "@/types/funnel/tripIdFunnelEvent";
import {
  DESELECT_CONTENT,
  SELECT_CONTENT,
} from "@/globalConsts/searchFunnelEvents";
import { pushToDataLayer } from "@/lib/gtm/dataLayer";

export function pushEventDataLayer(funnelEvent: DefaultFunnelEvent) {
  pushToDataLayer(funnelEvent);
}

export function getEventByContentType(
  inputEventProps: InputEventProps,
  contentType: string
): ContentIdFunnelEvent {
  return {
    content_id: inputEventProps.text,
    content_type: contentType,
    event: inputEventProps.checked ? SELECT_CONTENT : DESELECT_CONTENT,
  } as ContentIdFunnelEvent;
}

export function getTripIdFunnelEvent(tripIds: string): TripIdFunnelEvent {
  const travelNumbers = convertInputStringToTravelNumbers(tripIds);

  return {
    content_id: travelNumbers,
    content_type: "trip_id",
    event: SELECT_CONTENT,
  } as TripIdFunnelEvent;
}

function convertInputStringToTravelNumbers(input: string): number[] {
  return input
    .split(/[, ]/)
    .map((travelNumber) => parseInt(travelNumber.trim()))
    .filter((travelNumber) => !isNaN(travelNumber));
}
